<template>
  <!-- subscription form container -->
  <div class="subscription-form-container">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2 col-sm-12 offset-sm-0">
          <div class="subscription-container">
            <div class="subscription-image">
              <img src="/img/blog-subscribeForm-image.png" alt="">
            </div>
            <div class="abc">
              <h6 class="hf_heading06">Get insightful posts in your inbox weekly</h6>
              <form class="subscription-form-box">
                <div class="subscription-left-container">
                  <div class="form-group hf_input-container v">
                    <input type="text" class="form-control hf_customInput" v-model="email_address" maxlength="100" placeholder="Enter your email">
                    <p class="errorMessage" v-if="!isSubscribed && fieldMessage !==''">
                      <span class="errorCircle"><span class="errorSymbol">!</span></span>
                      {{ fieldMessage }}
                    </p>
                    <p class="successMessage" v-if="isSubscribed && fieldMessage !== ''">
                      <span class="successCircle"><i class="ph-check-bold"></i></span>
                      {{ fieldMessage }}
                    </p>
                  </div>
                </div>
                <div class="button-container">
                  <button type="button" :disabled="isFormSubmitting || (!isFormSubmitting && isSubscribed)" class="btn-primaryNoIcon lg-primarynoIcon" v-on:click="validateSubscribeForm()">{{ !isFormSubmitting ? 'Subscribe' : 'Processing..' }}</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="blog-recaptcha">
            <VueRecaptcha sitekey="6Ldr460jAAAAAO6wyw1mVTSg_2T2Zp9WTkO9SL_9" ref="recaptcha" size="invisible"
              :load-recaptcha-script="true" @verify="recaptchaVerified" @expired="recaptchaExpired" @error="recaptchaFailed">
            </VueRecaptcha>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- end subscription form container -->
</template>
<script>
import { VueRecaptcha } from 'vue-recaptcha';

export default {
  components: {
    VueRecaptcha
  },
  data() {
    return {
      email_address: "",
      isSubscribed: false,
      fieldMessage : "",
      recaptchaToken: "",
      isFormSubmitting:false,
    };
  },
  watch: {
    email_address(emailAddress) {
      this.email_address = emailAddress;
      if (this.email_address.length > 0 && !this.validateEmail(this.email_address)){ // Check is valid entered email
        this.fieldMessage = "Please enter valid Email Address.";
      }
      else{
         this.fieldMessage = "";
      }
    },
  },
  methods: {
    async recaptchaVerified(token) {
      // console.log(token);
      if (token ) this.recaptchaToken = token;
      let params = {
        'g-recaptcha-response': this.recaptchaToken
      };
      this.isSubscribed = false; this.isFormSubmitting = true;
      await axios.post('/verify-g-captcha', params).then((apiResponse) => {
        // console.log(apiResponse);
        if (apiResponse.hasOwnProperty('data')) {
          if (apiResponse.data.hasOwnProperty('status') && apiResponse.data.status == 1) {
           
            // Clevertap event pending
            clevertap.profile.push({
              "Site": {
                "Identity":this.email_address,
                "Email": this.email_address,
                "MSG-email": true,
                "MSG-dndEmail": false
              }
            });
            clevertap.event.push("Subscribe",{
              "Email":this.email_address,
              "page name": "Blogs",
              "Source" : "HF"
            });

            this.fieldMessage = "Subscribed Successfully.";
            this.isSubscribed = true;
            this.isFormSubmitting = false;

            setTimeout(()=>{
              this.fieldMessage ="";
              this.isSubscribed = false;
              this.email_address = "";
              this.$refs.recaptcha.reset();
            },2000);
            
          }
        }
      });
    },
    recaptchaExpired() {
      // console.log("_______ recaptchaExpired ______");
      this.$refs.recaptcha.reset();
      this.recaptchaToken = "";
      this.isFormSubmitting = false;
    },
    recaptchaFailed() {
      // console.log("_______ recaptchaFailed ______");
      this.recaptchaToken = "";
      this.isFormSubmitting = false;
    },
    async validateSubscribeForm() {
      // console.log("----schedule session form submit ------");
      if( this.email_address.length > 0 && this.validateEmail(this.email_address) ) {
        // console.log("Form is valid");
        this.$refs.recaptcha.execute();
      } 
      else {
        console.warn("Invalid form details");
        this.fieldMessage = "Please enter valid Email Address.";
        this.isFormSubmitting = false;
      }
    }
  }
};
</script>
